import { ENDPOINT_AI } from '../config'
import type { AiReindexJobsResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Recent reindex history for the Jobs panel. Joins ReindexJob rows with
 * Hangfire's live state. Pending rows whose enqueue failed surface as
 * `state = "Failed-to-enqueue"` so admins can see the orphan rather than
 * silently lose the click.
 */
export async function getReindexJobs(
  workspaceSlug: string,
  limit = 10,
): Promise<AiReindexJobsResponse> {
  const response = await AuthAxios.get<AiReindexJobsResponse>(
    `${ENDPOINT_AI(workspaceSlug)}/index/jobs`,
    { params: { limit } },
  )
  return response.data
}
